// plugins/vuetify.js
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Import Vuetify CSS styles
import 'vuetify/styles'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

export default function createVuetifyPlugin(palette = {}, i18n) {
  return createVuetify({
    components,
    directives,
    locale: {
      ...(i18n ? { adapter: createVueI18nAdapter({ i18n }) } : {}),
      locale: localStorage.getItem('lang') || 'en',
      fallback: 'en',
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: palette.primary || '#1976D2',
            secondary: palette.secondary || '#424242',
            accent: palette.accent || '#82B1FF',
            error: palette.error || '#FF5252',
            info: palette.info || '#2196F3',
            success: palette.success || '#4CAF50',
            warning: palette.warning || '#FFC107',
          },
        },
      },
    },
  })
}
